import axios from "axios/index";
import api from "../../config/_api";
import {STRUCTURE_UPDATED,INVALID_TOKEN} from "../actions/structure";
//import {isSubscriptionValid} from "../modules/auth";
import { USER_ERROR} from '../actions/user'
import {AUTH_LOGOUT} from '../actions/auth'

import router from '../../router/index.js';


const state = {
    structure: []
};
const actions = {
    getStructure: ({commit, rootGetters}) => {
        //var option = "";
        axios({url: api.url + 'structures?token=' + sessionStorage.getItem('user-token') +'&id=' + rootGetters.structure_id, method: 'GET' })
            .then(function (resp) {
                //On modifie les dates pour que celle-ci puise être affichées dans les date picker
                var struct;
                for(struct of resp.data){
                    struct.cloture_exercice = struct.cloture_exercice.substr(0,10);
                }
                commit('STRUCTURE_UPDATED', resp.data);
            })
            .catch(function (err){
                console.log(err);
                if((err.response.status == 401) || (err.response.status == 403) || (err.response.status == 400 )){
                    //this.$router.push("/logout");
                    router.push("/logout");
                    commit('INVALID_TOKEN');
                }
            }.bind(this));
    }
};
const mutations = {
    [STRUCTURE_UPDATED]: (state,structure) => {
        state.structure = structure;
    },
    [INVALID_TOKEN]: (state) => {
        state.structure = [];
    },
};
const getters = {
    structure : state => state.structure,
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
//# sourceMappingURL=sensors.js.map